// src/hooks/useImageUpload.ts
import { useState } from "react";
import { uploadFile } from "../utils/uploadService";
import { useSessionStorage } from "./useSessionStorage";
import { usePreviewUrl } from "./usePreviewUrl";
import { closeLoading, notifyLoading, notifySuccess } from "src/assets/toastService";
import { errorHandling } from "src/shared/services/errorHandling";
import useUsers from "src/business-types/grocery/hooks/useUsers";

interface UploadResult {
  success: boolean;
  data?: any;
  error?: any;
  previewUrl?: string;
}

export const useImageUpload = () => {
  const [uploading, setUploading] = useState(false);
  const { setItem } = useSessionStorage();
  const [file, setFile] = useState<File | null>(null);
  const previewUrl = usePreviewUrl(file);
  const { reload } = useUsers();

  const uploadImage = async (
    file: File,
    endpoint: string,
    method: "post" | "put" = "post",
    filename?: string,
    sessionKey?: string
  ): Promise<UploadResult> => {
    notifyLoading("Please wait, uploading logo...");
    setUploading(true);
    setFile(file);
    const localPreviewUrl = URL.createObjectURL(file);
    try {
      const response = await uploadFile(file, endpoint, method, filename);
      closeLoading();
      reload();
      notifySuccess("Logo update Sucessfully");
      if (sessionKey) setItem(sessionKey, filename || localPreviewUrl);
      return { success: true, data: response.data, previewUrl: localPreviewUrl || "" };
    } catch (error) {
      console.error("Image upload error:", error);
      closeLoading();
      errorHandling(error);
      return { success: false, error };
    } finally {
      setUploading(false);
    }
  };

  return { uploadImage, uploading, previewUrl };
};
